import { FunctionComponent } from 'react';
import { DraftBendingTextConfiguration } from '@/types';
import { RendererProps } from '../ConfigurationRenderer';
import { useBendingText } from './useBendingText';

export const BendingTextReadOnlyRenderer: FunctionComponent<
  RendererProps<DraftBendingTextConfiguration>
> = ({ configuration }) => {
  const [textElement, transform] = useBendingText(configuration);

  return <g transform={transform}>${textElement}</g>;
};
